export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('radio');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;

    DOMC.addType('radio', {
        isComponent(el) {
            if (el.tagName === 'INPUT' && el.type === 'radio') {
                return { type: 'radio' };
            }
        },
        extend: 'radio',
        extendFn: ['updateTraits'],
        model: {
            defaults: {
                // ...MODEL.prototype.defaults,
                traits: MODEL.prototype.defaults.traits.concat([
                    {
                        type: 'checkbox',
                        name: 'data-lg-follow-in-query',
                        label: 'Follow in query',
                        changeProp: false
                    }
                ])
            },
            init() {
                this.updateTrait('checked', {
                    changeProp: false
                });
            },
            addFollowInQuery() {
                if (!this.getTrait('data-lg-follow-in-query')) {
                    this.addTrait({
                        type: 'checkbox',
                        name: 'data-lg-follow-in-query',
                        label: 'Follow in query'
                    })
                }
            }

        },
    });
}
